var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_3322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 11.8348C14.666 12.7465 14.3544 13.6308 13.783 14.3412C13.2116 15.0517 12.4148 15.5457 11.5243 15.7415L11.099 14.4655C11.4885 14.4013 11.8589 14.2516 12.1835 14.027C12.5082 13.8025 12.7789 13.5087 12.9763 13.1668H11.333C10.9794 13.1668 10.6402 13.0264 10.3902 12.7763C10.1402 12.5263 9.99967 12.1871 9.99967 11.8335V9.16683C9.99967 8.81321 10.1402 8.47407 10.3902 8.22402C10.6402 7.97397 10.9794 7.8335 11.333 7.8335H13.2917C13.129 6.54476 12.5016 5.35968 11.5273 4.50061C10.553 3.64155 9.29864 3.16755 7.99967 3.16755C6.70071 3.16755 5.44639 3.64155 4.47206 4.50061C3.49773 5.35968 2.87036 6.54476 2.70767 7.8335H4.66634C5.01996 7.8335 5.3591 7.97397 5.60915 8.22402C5.8592 8.47407 5.99967 8.81321 5.99967 9.16683V11.8335C5.99967 12.1871 5.8592 12.5263 5.60915 12.7763C5.3591 13.0264 5.01996 13.1668 4.66634 13.1668H2.66634C2.31272 13.1668 1.97358 13.0264 1.72353 12.7763C1.47348 12.5263 1.33301 12.1871 1.33301 11.8335V8.50016C1.33301 4.81816 4.31767 1.8335 7.99967 1.8335C11.6817 1.8335 14.6663 4.81816 14.6663 8.50016V11.8348ZM13.333 11.8335V9.16683H11.333V11.8335H13.333ZM2.66634 9.16683V11.8335H4.66634V9.16683H2.66634Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_3322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.93bcbdcd.svg";
export { ForwardRef as ReactComponent };